export const SET_LOGS = 'Logs/set';
